/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetNoContractAdditionalInfoDto
 */
export interface GetNoContractAdditionalInfoDto {
    /**
     * 
     * @type {string}
     * @memberof GetNoContractAdditionalInfoDto
     */
    estimateItemId: string;
    /**
     * 
     * @type {string}
     * @memberof GetNoContractAdditionalInfoDto
     */
    text: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetNoContractAdditionalInfoDto
     */
    checked: boolean;
}

/**
 * Check if a given object implements the GetNoContractAdditionalInfoDto interface.
 */
export function instanceOfGetNoContractAdditionalInfoDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "estimateItemId" in value;
    isInstance = isInstance && "text" in value;
    isInstance = isInstance && "checked" in value;

    return isInstance;
}

export function GetNoContractAdditionalInfoDtoFromJSON(json: any): GetNoContractAdditionalInfoDto {
    return GetNoContractAdditionalInfoDtoFromJSONTyped(json, false);
}

export function GetNoContractAdditionalInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetNoContractAdditionalInfoDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'estimateItemId': json['estimateItemId'],
        'text': json['text'],
        'checked': json['checked'],
    };
}

export function GetNoContractAdditionalInfoDtoToJSON(value?: GetNoContractAdditionalInfoDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'estimateItemId': value.estimateItemId,
        'text': value.text,
        'checked': value.checked,
    };
}

